var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8732 9.28282L10.9459 8.10665C10.793 8.04497 10.6261 8.02013 10.4604 8.0344C10.2947 8.04867 10.1355 8.1016 9.99719 8.18836L8.432 9.16649C7.47541 8.73031 6.70117 8.00766 6.23169 7.11279L6.23181 7.11267L7.27148 5.62334C7.36198 5.49404 7.41689 5.34574 7.43129 5.19168C7.44569 5.03762 7.41913 4.88262 7.354 4.74054L6.09827 1.99379C6.01279 1.80734 5.86519 1.65186 5.67757 1.55064C5.48994 1.44942 5.2724 1.40789 5.0575 1.43229C4.21304 1.53408 3.43699 1.9206 2.87432 2.51965C2.31166 3.1187 2.00086 3.8893 2 4.6875C2 9.33998 6.03735 13.125 11 13.125C11.8514 13.1242 12.6734 12.8328 13.3124 12.3053C13.9514 11.7778 14.3637 11.0502 14.4722 10.2585C14.4982 10.0571 14.4538 9.85314 14.3459 9.67726C14.2379 9.50138 14.0721 9.36299 13.8732 9.28282V9.28282Z",
    fill: "#FF6978"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.f3aaf0450ee802c188ed95461dac75dc.svg";
export { ForwardRef as ReactComponent };